__turbopack_context__.v({
  "headerWrapper": "BhrHKW_headerWrapper",
  "reservationHeader": "BhrHKW_reservationHeader",
});
